module.exports = __webpack_public_path__ + "static/media/vivekananda.0b21f8ac.png";